import React from 'react';
import { Box, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const StyledBox = styled(Box)(() => ({
    width: '100%',
    padding: '10px 3.175% 11px',
}));

const BottomFooter = () => {

    const { t } = useTranslation();

    return (
        <StyledBox>
            <Typography>{t('FOOTER.COPYRIGHT')}</Typography>
        </StyledBox>
    );
};

export default BottomFooter;
